module.exports = __webpack_public_path__ + "img/btn.8a48e453.png";